import React, { useState, useEffect, useCallback } from "react";
import toursData from "../mock/tours";
import { AutoAwesome, WorkspacePremium } from "@mui/icons-material";
import ReservationModal from "./ReservationModal";

const ToursSection = () => {
  const [modalTour, setModalTour] = useState(null);

  const openModal = useCallback((tour) => {
    setModalTour(tour);
  }, []);

  const closeModal = useCallback(() => {
    setModalTour(null);
  }, []);

  const toursToShow = toursData.slice(0, 10);

  return (
    <section id="tours" className="scroll-mt-24 py-12">
      <div className="container mx-auto px-4">
        <div className="text-center lg:mb-8 mb-2 px-[5%]">
          <div className="inline-block relative group">
            <h2
              className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-pink-500 to-red-600 tracking-wide flex items-center justify-center gap-2"
              data-aos="zoom-in-up"
              data-aos-duration="600"
            >
              <AutoAwesome
                className="w-5 h-5 text-yellow-400 mr-4 animate-ping"
                fontSize="large"
              />
              Servicio de TOURS e INTERPRETACIÓN por toda China
              <AutoAwesome
                className="w-5 h-5 text-yellow-400 ml-4 animate-ping"
                fontSize="large"
              />
            </h2>
          </div>
          <p
            className="mt-4 text-white max-w-3xl mx-auto text-base sm:text-lg font-medium italic leading-relaxed"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            Creamos tu aventura al máximo, sea por turismo o negocios.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {toursToShow.map((tour) => (
            <div
              key={tour.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden transition-transform duration-300 ease-in-out hover:shadow-[0_0_15px_6px_rgba(168,85,247,0.8)] hover:brightness-110 cursor-pointer"
              data-aos="fade-up"
            >
              <div className="relative">
                <img
                  src={tour.image}
                  alt={tour.name}
                  className="w-full h-64 object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40" />
                <div className="absolute inset-0 flex items-center justify-center z-10">
                  <h3 className="text-3xl font-bold text-white drop-shadow-xl text-center px-2">
                    {tour.name}
                  </h3>
                </div>
              </div>
              <div className="p-6">
                <ul className="mb-4">
                  {tour.includes.map((item, index) => (
                    <li key={index} className="flex items-center mb-2">
                      <svg
                        className="w-4 h-4 text-yellow-500 mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="https://wa.me/8613683676407?text=Hola,%20estoy%20interesado%20en%20tus%20viajes%20a%20China."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-gradient-to-r from-yellow-500 to-pink-500 hover:from-yellow-600 hover:to-pink-600 text-white font-bold py-2 px-4 rounded-lg transition-colors duration-300 inline-block text-center"
                >
                  ¡Reservar ahora!
                  <WorkspacePremium className="w-4 h-4 ml-2" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
      {modalTour && <ReservationModal tour={modalTour} onClose={closeModal} />}
    </section>
  );
};

export default ToursSection;
